var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 0H2.375C1.33945 0 0.5 0.839542 0.5 1.8752V18.7481C0.5 19.713 1.54648 20.3139 2.37969 19.8279L8 16.5486L13.6211 19.8275C14.4531 20.2795 15.5 19.713 15.5 18.7481V1.8752C15.5 0.839542 14.6602 0 13.625 0ZM13.625 17.6581L8 14.3765L2.375 17.6581V2.1096C2.375 1.97794 2.47773 1.8752 2.57422 1.8752H13.3555C13.5234 1.8752 13.625 1.97794 13.625 2.1096V17.6581Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkRegular);
export default __webpack_public_path__ + "static/media/bookmark-regular.5d6a342984f38760190787b2c9ec1a2f.svg";
export { ForwardRef as ReactComponent };